import React, { useState } from "react";
import GetStartedDialog from "./home-components/GetStartedDialog";
import CircularText from "./CircularText";
import FooterLogo from "./../assets/images/DarkLogo (1).png";
import LanguageIcon from "@mui/icons-material/Language";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailIcon from "@mui/icons-material/Mail";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
export default function Footer() {
  const [open, setOpen] = useState(false);

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);
  return (
    <footer
      style={{
        backgroundImage:
          "linear-gradient(254.54deg, #F0FF6C 0.03%, #6BFDD9 100%)",
        backgroundColor: "transparent",
      }}
      className="text-[#0B2E2B]"
    >
      <div className="max-w-7xl mx-auto ">
        {/* ================= TOP CTA ================= */}
        <div className="px-6 pt-24 pb-16">
          <div className="flex flex-row items-start justify-between gap-12">
            {/* Left */}
            <div>
              <h2 className="text-[26px] md:text-[50px] xl:text-[70px] font-extrabold leading-tight uppercase">
                Let’s Work Together
              </h2>
              <p className="mt-2 text-[14px] md:text-[18px] xl:text-[20px] font-medium text-[#163031]">
                Building scalable web applications with modern technologies.
              </p>
            </div>

            {/* Circular CTA */}

            <div onClick={handleOpenDialog} className="cursor-pointer">
              <CircularText
                text="GET STARTED NOW * GET STARTED NOW *"
                spinDuration={20}
                onHover="speedUp"
                className="hidden xl:block"
              />
            </div>
          </div>
        </div>

        <hr className="border-black/20" />

        {/* ================= FOOTER CONTENT ================= */}
        <div className="px-6 py-16 grid grid-cols-1 md:grid-cols-[1fr_2fr_2fr] xl:grid-cols-[2fr_0.8fr_1.1fr_1fr] gap-12">
          {/* BRAND */}
          <div className="md:col-span-3 xl:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={FooterLogo} alt="Logo" />
            </div>

            <p className="text-[16px] font-normal w-[80%]">
              MERN Stack Developer with 3+ years of experience building
              responsive websites and full-stack web applications using modern
              JavaScript technologies.
            </p>

            {/* Social Icons */}
            <div className="flex gap-3 mt-5">
              {/* Call */}
              <a
                href="tel:+919110385435"
                className="bg-[#0B2E2B] text-[#F8F8F8] rounded-full w-10 h-10 flex justify-center items-center hover:scale-105 transition"
              >
                <CallIcon />
              </a>

              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/in/divya-sri-kandavalli-61b1742b4/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#0B2E2B] text-[#F8F8F8] rounded-full w-10 h-10 flex justify-center items-center hover:scale-105 transition"
              >
                <LinkedInIcon />
              </a>

              {/* Email */}
              <a
                href="mailto:divyasrikandavalli12@gmail.com"
                className="bg-[#0B2E2B] text-[#F8F8F8] rounded-full w-10 h-10 flex justify-center items-center hover:scale-105 transition"
              >
                <MailIcon />
              </a>

              {/* WhatsApp */}
              <a
                href="https://wa.me/919110385435"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#0B2E2B] text-[#F8F8F8] rounded-full w-10 h-10 flex justify-center items-center hover:scale-105 transition"
              >
                <WhatsAppIcon />
              </a>

              {/* Website / Portfolio */}
              <a
                href="/"
                className="bg-[#0B2E2B] text-[#F8F8F8] rounded-full w-10 h-10 flex justify-center items-center hover:scale-105 transition"
              >
                <LanguageIcon />
              </a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h4 className="text-[20px] font-semibold mb-5">Quick Links</h4>
            <ul className="space-y-3 text-[16px] font-medium leading-[1.6em]">
              <li
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="cursor-pointer hover:opacity-70 transition"
              >
                Home
              </li>

              <li>
                <a href="#about" className="hover:opacity-70 transition">
                  About
                </a>
              </li>

              <li>
                <a href="#skills" className="hover:opacity-70 transition">
                  Skills
                </a>
              </li>

              <li>
                <a href="#projects" className="hover:opacity-70 transition">
                  Projects
                </a>
              </li>
            </ul>
          </div>

          {/* SERVICES */}
          <div>
            <h4 className="text-[20px] font-semibold mb-5">Skills</h4>
            <ul className="space-y-3 text-[16px] font-medium leading-[1.6em]">
              <li>React.js Development</li>
              <li>Node.js & Express APIs</li>
              <li>MongoDB Integration</li>
              <li>Responsive UI Development</li>
            </ul>
          </div>

          {/* WORK */}
          <div>
            <h4 className="text-[20px] font-semibold mb-5">Profiles</h4>
            <ul className="space-y-3 text-[16px] font-medium leading-[1.6em]">
              <li>
                <a
                  href="https://www.linkedin.com/in/divya-sri-kandavalli-61b1742b4/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-70 transition"
                >
                  LinkedIn
                </a>
              </li>

              <li>
                <a
                  href="https://github.com/divyasri-kandavalli/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-70 transition"
                >
                  GitHub
                </a>
              </li>

              <li>
                <a href="/" className="hover:opacity-70 transition">
                  Portfolio
                </a>
              </li>

              <li>
                <a
                  href="mailto:divyasrikandavalli12@gmail.com"
                  className="hover:opacity-70 transition"
                >
                  Email Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="border-black/20" />

        {/* ================= COPYRIGHT ================= */}
        <div className="text-start py-6 text-[16px] font-normal">
          Copyright © 2026 All Rights Reserved.
        </div>
      </div>
      <GetStartedDialog open={open} onClose={handleCloseDialog} />
    </footer>
  );
}
